<!-- Modal Principal - Visualização do Profissional -->
<!-- Mobile: Bottom Sheet -->
@if (deviceService.$isMobile()) {
<lib-bottom-sheet
  [visible]="$internalVisible()"
  (visibleChange)="$internalVisible.set($event)"
  size="full"
  [draggable]="true"
  [closeOnBackdrop]="true"
  [closeOnEscape]="true"
  [headerTemplate]="headerTemplateView"
  [footerTemplate]="
    activeTab() !== 'view' ? footerTemplate ?? undefined : undefined
  "
  (hide)="fechar()"
>
  <ng-container *ngTemplateOutlet="conteudoView"></ng-container>
</lib-bottom-sheet>
} @else {
<!-- Desktop: Dialog -->
<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '520px', maxWidth: '95vw' }"
  (onHide)="fechar()"
>
  <ng-template pTemplate="header">
    <ng-container *ngTemplateOutlet="headerTemplateView"></ng-container>
  </ng-template>
  <ng-container *ngTemplateOutlet="conteudoView"></ng-container>
  <ng-template pTemplate="footer">
    @if (footerTemplate && activeTab() !== 'view') {
    <ng-container *ngTemplateOutlet="footerTemplate"></ng-container>
    }
  </ng-template>
</p-dialog>

}

<!-- Template de header -->
<ng-template #headerTemplateView>
  <div class="w-full">
    <div
      class="pr-1 pl-1 pb-2 pt-2 border-round-lg lg:col-12 n-header-gradient"
    >
      <div class="n-header-content">
        <div class="sm:col-12 md:col-8">
          <span class="n-header-title text-white font-bold">
            @if (activeTab() === 'criar') {
            <i class="pi pi-user-plus mr-2"></i>
            {{ 'BARDO_PROFISSIONAIS.NOVO' | translate: { termo: $nicho().profissional.singular } }} } @else if (activeTab() === 'editar') {
            <i class="pi pi-pencil mr-2"></i>
            {{ 'BARDO_PROFISSIONAIS.EDITAR' | translate: { termo: $nicho().profissional.singular } }} } @else if (activeTab() === 'ausencias') {
            <i class="pi pi-calendar-times mr-2"></i>
            {{ 'BARDO_PROFISSIONAIS.AUSENCIAS_DE' | translate: { termo: $nicho().profissional.singular } }} } @else {
            <i class="pi pi-id-card mr-2"></i>
            {{ 'BARDO_PROFISSIONAIS.FICHA_DE' | translate: { termo: $nicho().profissional.singular } }} }
          </span>

        </div>
        <div class="sm:col-12 md:col-4 flex justify-content-end gap-2">
          @if (!deviceService.$isMobile()) {
          <button
            type="button"
            class="n-close-btn"
            (click)="fechar()"
            [attr.aria-label]="'GLOBAL.FECHAR' | translate"
          >
            <i class="pi pi-times"></i>
          </button>
          }
        </div>
      </div>
    </div>
    @if (activeTab() !== 'criar') {
    <div class="lg:col-12 n-profissional-tabs">
      <p-tabs [value]="activeTab()" libTabsInkbarFix>
        <p-tablist>
          @for (tab of tabs; track tab.id) { @if (tabVisivel(tab.id)) {
          <p-tab
            [value]="tab.id"
            class="flex items-center !gap-2 text-inherit"
            (click)="onTabChange(tab.id)"
          >
            <i [class]="tab.icon"></i>
            <span>{{ tab.labelKey | translate }}</span>
          </p-tab>
          } }
        </p-tablist>
      </p-tabs>
    </div>
    }
  </div>
</ng-template>

<!-- Template de conteúdo compartilhado -->
<ng-template #conteudoView>
  @switch (activeTab()) { @case ('view') {
  <lib-profissional-info [profissional]="profissional" (closed)="fechar()" />
  } @case ('editar') {
  <lib-profissional-create-edit
    [profissional]="profissional"
    (footerTemplateAction)="footerTemplateAction($event)"
    (footerReset)="resetFooterTemplate()"
    (closed)="fecharAbaCriarEditar()"
  />
  } @case ('ausencias') {
  <lib-profissional-ausencias
    [profissional]="profissional!"
    (footerTemplateAction)="footerTemplateAction($event)"
    (footerReset)="resetFooterTemplate()"
  />
  } @case ('criar') {
  <lib-profissional-create-edit
    [resetKey]="resetKey()"
    (footerTemplateAction)="footerTemplateAction($event)"
    (footerReset)="resetFooterTemplate()"
    (closed)="fecharAbaCriarEditar()"
  />
  } }
</ng-template>
